'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibScreenReaderDescription = require('./components/BibScreenReaderDescription.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibScreenReaderDescription).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-screen-reader-description/lib/index.js
// module id = 365
// module chunks = 1